import React, { Component } from 'react'

class StixInfos extends Component {
  render () {
    return (
      <div className='row'>
        <div className='col-12 px-2 py-2'>
          <p className='txt-body'>Veja o que você precisa saber:</p>
        </div>
        <div className='col-12 px-2'>
          <div className='row'>
            <div className='col-12 col-md-6 py-1'>
              <div className='row h-100 align-items-center  border border-color-ui-3 radius mx-0 py-2'>
                <div className='col-auto'>
                  <i className='icon-custom icon_dot_down color-featured' />
                </div>
                <div className='col'>
                  <p className='txt-body-sm'>
                    1 {process.env.REACT_APP_STIX_CURRENCY || 'ponto' } = 1 ponto stix.
                    <br />
                    A transferência é gratuita.
                  </p>
                </div>
              </div>
            </div>
            <div className='col-12 col-md-6 py-1'>
              <div className='row h-100 align-items-center  border border-color-ui-3 radius mx-0 py-2'>
                <div className='col-auto'>
                  <i className='icon-custom icon_user color-featured' />
                </div>
                <div className='col'>
                  <p className='txt-body-sm'>
                    Os pontos stix serão
                    <br />
                    creditados automaticamente
                    <br />
                    no mesmo CPF da sua
                    <br />
                    conta { process.env.REACT_APP_TITLE}
                  </p>
                </div>
              </div>
            </div>
            <div className='col-12 col-md-6 py-1'>
              <div className='row h-100 align-items-center  border border-color-ui-3 radius mx-0 py-2'>
                <div className='col-auto'>
                  <i className='icon-custom icon_phone color-featured' />
                </div>
                <div className='col'>
                  <p className='txt-body-sm'>
                    Você poderá trocar seus stix por
                    <br />
                    recompensas incríveis no app da
                    <br />
                    Stix.
                  </p>
                </div>
              </div>
            </div>
            <div className='col-12 col-md-6 py-1'>
              <div className='row h-100 align-items-center  border border-color-ui-3 radius mx-0 py-2'>
                <div className='col-auto'>
                  <i className='icon-custom icon_promo color-featured' />
                </div>
                <div className='col'>
                  <p className='txt-body-sm'>
                    Dá para trocar seus pontos stix por
                    <br />
                    vale-compras, produtos e serviços
                    <br />
                    do Pão de Açúcar, Droga Raia, Extra,
                    <br />
                    Drogasil e muitos outros parceiros.
                  </p>
                </div>
              </div>
            </div>
            <div className='col-12 col-md-6 py-1'>
              <div className='row h-100 align-items-center  border border-color-ui-3 radius mx-0 py-2'>
                <div className='col-auto'>
                  <i className='icon-custom icon_bag color-featured' />
                </div>
                <div className='col'>
                  <p className='txt-body-sm'>
                    Após escolher sua recompensa,
                    <br />
                    siga as instruções para retirá-la
                    <br />
                    na loja física ou online,
                    <br />
                    dependendo do parceiro.
                  </p>
                </div>
              </div>
            </div>
            <div className='col-12 col-md-6 py-1'>
              <div className='row h-100 align-items-center  border border-color-ui-3 radius mx-0 py-2'>
                <div className='col-auto'>
                  <i className='icon-custom icon_info color-featured' />
                </div>
                <div className='col'>
                  <p className='txt-body-sm'>
                    Para mais informações
                    <br />
                    <a href={`${process.env.REACT_APP_ZENDESK_URL}hc/pt-br/sections/360006573912-transfer%C3%AAncia-de-pontos`} className='color-brand-2 txt-underline txt-body-sm'>clique aqui</a>.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default StixInfos



// WEBPACK FOOTER //
// ./src/features/Stix/StixInfos.js